import React, { useEffect, useState } from 'react';
import '../Components/CSS/Global.css';
import ContactPng from './img/contactme.png'
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
    const fullUrl = window.location.href;
    const [formData, setFormData] = useState({
        contactName: '',
        contactEmail: '',
        contactMessage: '',
        contactPhone: '',
        contactService: '',
        dob:"Website"
    });
    const [isHumanChecked, setIsHumanChecked] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [checkboxErrors, setCheckboxErrors] = useState({
        isHuman: false,
        terms: false,
    });

    const [services, setServices] = useState([]);

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value; // Remove leading and trailing spaces

        if (name === "contactPhone") {
            updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 10); // Allow only numbers and limit to 10 digits

            // Remove leading zero
            if (updatedValue.startsWith("0")) {
                updatedValue = updatedValue.slice(1);
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));

        // Validation for phone number
        if (name === "contactPhone") {
            if (value.startsWith("0")) {
                setError("Phone number cannot start with 0");
            } else if (updatedValue.length < 10) {
                setError("Phone number must be 10 digits long");
            } else {
                setError("");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isHumanChecked || !agreedToTerms) {
            setCheckboxErrors({
                isHuman: !isHumanChecked,
                terms: !agreedToTerms,
            });
            return;
        }
        setLoading(true);

        try {
            const response = await fetch('https://100billionrealestate.com/inquiry', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.contactName,
                    email: formData.contactEmail,
                    mobile: formData.contactPhone,
                    school: formData.contactService,
                    remark: formData.contactMessage,
                    parent_name: 'Contact Inquiry',
                    skates_category: fullUrl,
                    dob:"Website"
                }),
            });

            if (response.ok) {
                toast.success("Thank you! Our team will contact you soon.", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });
                setFormData({
                    contactName: '',
                    contactEmail: '',
                    contactMessage: '',
                    contactPhone: '',
                    contactService: '',
                    dob:"Website"
                })
                setIsHumanChecked(false)
                setAgreedToTerms(false)
            } else {
                console.log('Error submitting form');
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }

    };

    const servicesAllFetch = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/centerlist/100billiontechservice`)
            const res = await response.json();
            console.log(res);
            const extractedServices = res.map(item => item.center_name);
            setServices(extractedServices);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        servicesAllFetch();
    }, {})

    return (
        <>
            <div className="contact-page">
                <div className="hero">
                    <h1>Contact Us</h1>
                </div>

                <div className="contact-section">
                    <div className="illustration">
                        <img src={ContactPng} alt="Contact Illustration" />
                    </div>
                    <div className="form-container">
                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="contactName"
                                placeholder="Your Name"
                                required
                                value={formData.contactName}
                                onChange={handleChange}
                            />
                            <input
                                type="email"
                                name="contactEmail"
                                placeholder="Your Email"
                                required
                                value={formData.contactEmail}
                                onChange={handleChange}
                            />
                            <input
                                type="number"
                                name="contactPhone"
                                placeholder="Your Mobile"
                                required
                                value={formData.contactPhone}
                                onChange={handleChange}
                                className='number-contact-input'
                            />
                            {error && <p className="error-message-form error-contact-message">{error}</p>}
                            <select
                                name="contactService"
                                required
                                value={formData.contactService}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select a Service</option>
                                {
                                     services.map((service, index) => (
                                        <option key={index} value={service}>{service}</option> 
                                     ))}
                            </select>
                            <textarea
                                name="contactMessage"
                                rows="5"
                                placeholder="Your Message"
                                required
                                value={formData.contactMessage}
                                onChange={handleChange}
                            ></textarea>
                            <div className="form-mainfieldcheck-hbt">
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="isHuman"
                                        className="humanischeckedcontact-hbt"
                                        checked={isHumanChecked}
                                        onChange={(e) => {
                                            setIsHumanChecked(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, isHuman: false }));
                                        }}
                                    />
                                    
                                    <p className="form-terms-hbt">Please check the box to confirm you're human</p>
                                    
                                    

                                </div>
                                {checkboxErrors.isHuman && <p className="error-message-form">Please confirm you're human</p>}
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        className="humanischeckedcontact-hbt"
                            
                                        checked={agreedToTerms}
                                        onChange={(e) => {
                                            setAgreedToTerms(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, terms: false }));
                                        }}
                                    />
                                    <p className="form-terms-hbt">By submitting, you agree to our <span onClick={() => window.open("https://100billiontech.com/terms-and-conditions", "_blank", "noopener,noreferrer")} style={{cursor:"pointer",color:"#4685f6"}}>terms and conditions</span></p>
                                   

                                </div>
                                {checkboxErrors.terms && <p className="error-message-form">You must agree to the terms</p>}
                            </div>
                            <button type="submit" disabled={loading}>
                                {loading ? (
                                    <div className="loader"></div>
                                ) : (
                                    'Send Message'
                                )}
                            </button>
                        </form>
                    </div>
                </div>

                <div className="location">
                    <h3>Our Location</h3>
                    <p><a href="https://maps.app.goo.gl/ctmvjkeTVRS8KDaJ8"><i className="fas fa-map-marker-alt"></i>  E-10 4th floor, Nemi Krishna Building, Jethwa Nagar Opposite Bajaj School, Kandivali West, 400067</a></p>
                    <p><a href="tel:+918433803555"><i className="fas fa-phone"></i> +91 8433-803-555</a></p>
                    <p><a href="tel:+917715863833"><i className="fas fa-phone"></i> +91 7715-863-833</a></p>
                    <p><a href="mailto:info@100billiontech.com"><i className="fas fa-envelope"></i> info@100billiontech.com</a></p>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default Contact;
